import { useCallback, useEffect } from 'react';
import useSocket from '../../../../shared/hooks/use-socket';
import { useReducerAtom } from 'jotai/utils';
import { socketConnectionAtom, socketConnectionReducer } from '../../../../shared/states/socket-connection';
import { SocketConnectionReducerActionTypes, SocketName } from '../../../../shared/typings/socket-connection';
import { getUserSocket } from '../../../../infra/sockets/user-socket';
import { useSetAtom } from 'jotai';
import { isOnlineAtom } from '../../../agent-availability/state';
import { AgentStatus } from '../../../agent-availability/typings';

interface StatusUpdatePayload {
  orgId: string;
  userId: string;
  status: string;
}

export const useUserSocket = () => {
  const [_, dispatch] = useReducerAtom(socketConnectionAtom, socketConnectionReducer);

  const { socket: userSocket } = useSocket(getUserSocket, undefined, false, undefined);

  const setIsOnline = useSetAtom(isOnlineAtom);

  const onStatusUpdate = useCallback(
    (payload: StatusUpdatePayload) => {
      setIsOnline(payload.status === AgentStatus.ONLINE);
    },
    [setIsOnline]
  );

  useEffect(() => {
    /**
     * This event handler is for agent availability status updates
     */
    userSocket.on('status-update', onStatusUpdate);

    return () => {
      userSocket.off('status-update', onStatusUpdate);
    };
  }, [onStatusUpdate, userSocket]);
};
